module.exports = __webpack_public_path__ + "c0c70965bcce806bd69c66228444de9e.png";